const Header: React.FC<{ address: string, alias?: string }> = ({ address, alias }) => {
    return <header className="header">
        <h1 className="header__title">🔗 Chain Scanner</h1>
        <span className="address">{ 'Address: ' + (alias ? alias + ' (' + address + ')' : address) }</span>
    </header>
}

export default Header;